// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.therapeutic_groups__27Aea {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-bottom: var(--space-6);
}
.therapeutic_groupTab__qlzXl {
  padding: 0.7rem 1.25rem;
  border: 1px solid var(--color-border-on-dark);
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--color-text-muted-on-dark);
  font-family: var(--font-sans);
  font-size: 0.975rem;
  cursor: pointer;
  transition: background var(--dur-fast) ease, color var(--dur-fast) ease;
}
.therapeutic_groupTab__qlzXl:hover {
  color: #fff;
  border-color: #fff;
}
.therapeutic_groupTab__qlzXl[aria-selected="true"] {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: #111;
  font-weight: 700;
}
.therapeutic_layout__8uxsC {
  display: grid;
  gap: var(--space-6);
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
}
.therapeutic_groupDesc__F1pv3 {
  margin: 0 0 var(--space-4);
  color: var(--color-text-muted-on-dark);
}
.therapeutic_chips__RmgVC,
.therapeutic_plain__LhnJt {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.therapeutic_chip__nDNTk {
  padding: 0.5rem 1rem;
  border: 1px solid var(--color-border-on-dark);
  border-radius: var(--radius-pill);
  background: transparent;
  color: #fff;
  font-family: var(--font-sans);
  font-size: 0.9rem;
  cursor: pointer;
  transition: background var(--dur-fast) ease, border-color var(--dur-fast) ease,
    color var(--dur-fast) ease;
}
.therapeutic_chip__nDNTk:hover {
  border-color: var(--color-accent);
}
.therapeutic_chip__nDNTk[aria-pressed="true"] {
  background: #fff;
  border-color: #fff;
  color: var(--color-ink);
  font-weight: 700;
}
.therapeutic_plain__LhnJt {
  flex-direction: column;
  gap: var(--space-3);
  color: #fff;
}
.therapeutic_plain__LhnJt a {
  color: var(--color-accent);
}
.therapeutic_detail__tu21o {
  padding: clamp(1.5rem, 1rem + 2vw, 2.5rem);
  border: 1px solid var(--color-border-on-dark);
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.04);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4);
}
.therapeutic_detailLabel__DxH-8 {
  margin: 0;
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: var(--color-accent);
  font-weight: 700;
}
.therapeutic_detailTitle__D9YnP {
  margin: 0;
  font-size: clamp(1.75rem, 1.25rem + 1.4vw, 2.4rem);\$1letter-spacing: var(--tracking-subheading);
  text-wrap: balance;
}
.therapeutic_detailText__XGksl {
  margin: 0;
  color: var(--color-text-muted-on-dark);
  line-height: var(--leading-body);
}
.therapeutic_people__D66Mh {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.35rem;
}
.therapeutic_people__D66Mh li {
  padding-left: 1rem;
  position: relative;
}
.therapeutic_people__D66Mh li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.65em;
  width: 0.5rem;
  height: 2px;
  background: var(--color-accent);
}
.therapeutic_places__LoD\\+x {
  margin: 0;
  font-size: var(--text-caption);
  color: var(--color-text-muted-on-dark);
}

@media (min-width: 992px) {
  .therapeutic_layout__8uxsC {
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);
    gap: var(--space-7);
  }
  .therapeutic_detail__tu21o {
    position: sticky;
    top: 6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/THERAPEUTIC/therapeutic.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,iCAAiC;EACjC,uBAAuB;EACvB,sCAAsC;EACtC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,uEAAuE;AACzE;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,iCAAiC;EACjC,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf;8BAC4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0CAA0C;EAC1C,6CAA6C;EAC7C,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kDAAkD,CAAC,4CAA4C;EAC/F,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,sCAAsC;EACtC,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE;IACE,wDAAwD;IACxD,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":[".groups {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  margin-bottom: var(--space-6);\n}\n.groupTab {\n  padding: 0.7rem 1.25rem;\n  border: 1px solid var(--color-border-on-dark);\n  border-radius: var(--radius-pill);\n  background: transparent;\n  color: var(--color-text-muted-on-dark);\n  font-family: var(--font-sans);\n  font-size: 0.975rem;\n  cursor: pointer;\n  transition: background var(--dur-fast) ease, color var(--dur-fast) ease;\n}\n.groupTab:hover {\n  color: #fff;\n  border-color: #fff;\n}\n.groupTab[aria-selected=\"true\"] {\n  background: var(--color-accent);\n  border-color: var(--color-accent);\n  color: #111;\n  font-weight: 700;\n}\n.layout {\n  display: grid;\n  gap: var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n  align-items: start;\n}\n.groupDesc {\n  margin: 0 0 var(--space-4);\n  color: var(--color-text-muted-on-dark);\n}\n.chips,\n.plain {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.chip {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--color-border-on-dark);\n  border-radius: var(--radius-pill);\n  background: transparent;\n  color: #fff;\n  font-family: var(--font-sans);\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: background var(--dur-fast) ease, border-color var(--dur-fast) ease,\n    color var(--dur-fast) ease;\n}\n.chip:hover {\n  border-color: var(--color-accent);\n}\n.chip[aria-pressed=\"true\"] {\n  background: #fff;\n  border-color: #fff;\n  color: var(--color-ink);\n  font-weight: 700;\n}\n.plain {\n  flex-direction: column;\n  gap: var(--space-3);\n  color: #fff;\n}\n.plain :global(a) {\n  color: var(--color-accent);\n}\n.detail {\n  padding: clamp(1.5rem, 1rem + 2vw, 2.5rem);\n  border: 1px solid var(--color-border-on-dark);\n  border-radius: var(--radius-lg);\n  background: rgba(255, 255, 255, 0.04);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-4);\n}\n.detailLabel {\n  margin: 0;\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  color: var(--color-accent);\n  font-weight: 700;\n}\n.detailTitle {\n  margin: 0;\n  font-size: clamp(1.75rem, 1.25rem + 1.4vw, 2.4rem);$1letter-spacing: var(--tracking-subheading);\n  text-wrap: balance;\n}\n.detailText {\n  margin: 0;\n  color: var(--color-text-muted-on-dark);\n  line-height: var(--leading-body);\n}\n.people {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 0.35rem;\n}\n.people li {\n  padding-left: 1rem;\n  position: relative;\n}\n.people li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0.65em;\n  width: 0.5rem;\n  height: 2px;\n  background: var(--color-accent);\n}\n.places {\n  margin: 0;\n  font-size: var(--text-caption);\n  color: var(--color-text-muted-on-dark);\n}\n\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);\n    gap: var(--space-7);\n  }\n  .detail {\n    position: sticky;\n    top: 6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groups": `therapeutic_groups__27Aea`,
	"groupTab": `therapeutic_groupTab__qlzXl`,
	"layout": `therapeutic_layout__8uxsC`,
	"groupDesc": `therapeutic_groupDesc__F1pv3`,
	"chips": `therapeutic_chips__RmgVC`,
	"plain": `therapeutic_plain__LhnJt`,
	"chip": `therapeutic_chip__nDNTk`,
	"detail": `therapeutic_detail__tu21o`,
	"detailLabel": `therapeutic_detailLabel__DxH-8`,
	"detailTitle": `therapeutic_detailTitle__D9YnP`,
	"detailText": `therapeutic_detailText__XGksl`,
	"people": `therapeutic_people__D66Mh`,
	"places": `therapeutic_places__LoD+x`
};
export default ___CSS_LOADER_EXPORT___;
